<template>
    <div class="newsList-index">
        <div class="newsList">
            <div class="center">
                <h1 class="common-font">{{news1.title}}</h1>
                <p class="newsTime">{{news1.date}}</p>
                <div v-if="news1.newsMes"
                     v-for="(item,index) in news1.newsMes "
                     :key=index
                     class="news-cont"
                >
                    <h2 v-show="item.hp">{{item.hp}}</h2>
                    <p v-show="item.p1" v-for="newsMes in item.p1">{{newsMes}}</p>
                    <img v-show="item.img1" v-for="newsImg in item.img1" :src="newsImg" alt="">
                    <span v-show="item.pro">{{item.pro}}
                        <a :href="item.url">{{item.url}}</a>
                    </span>
                </div>
                <div class="news-cont"
                     v-html="news1.newsHtml"
                >
                </div>
            </div>

        </div>
    </div>
</template>

<script>
  import newsDetail from '../../assets/js/newsDetail'

  export default {
    name: 'news0505',
    data () {
      return {

        news1: {},
        newsOne: newsDetail.newsLists
      }
    },
    watch: {
      $route () {
        //  只要路径变化，重新获取数据
        // this.getData()
        this.findOneNews()
      }
    },
    created () {
      this.findOneNews()
      // this.getData()
      // this.findOneNews('news0505');

    },

    methods: {
      findOneNews () {
        var self = this.news1
        var _id = this.$route.params.bid
        this.newsOne.find((item) => {
          if (item['newsId'] === _id) {
            self = item
          }
        })
        this.news1 = self
        // console.log(this.news1.newsHtml);
        // 如果是空对象，需要跳转回列表页
        Object.keys(self).length > 0 ? void 0 : this.$router.push('/newsList')
      },
    }
  }
</script>

<style lang="less">
    .newsList-index {
        @baseWidth: 800px;
        width: 100%;
        min-width: 1216px;

        .common-font {
            font-family: 'Gotham-Medium', "Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }

        .center {
            width: @baseWidth;
            margin: 0 auto;
        }

        .newsList {
            padding-bottom: 96px;
        }

        h1 {
            font-size: 28px;
            color: #252525;
            line-height: 44px;
            margin: 187px auto 24px;
        }

        p.newsTime {
            font-size: 16px;
            color: #5D5D5D;
            line-height: 26px;
            margin-bottom: 32px;
        }

        .news-cont {
            text-align: left;

            h2 {
                font-size: 18px;
                color: #252525;
                line-height: 24px;
                margin: 32px 0;
            }

            p {
                font-size: 14px;
                color: #5D5D5D;
                line-height: 26px;
                margin-bottom: 32px;
            }

            img {
                display: block;
                width: 100%;
                margin-bottom: 32px;
            }

            span {
                display: block;
                color: #5D5D5D;
                margin-bottom: 32px;

                a {
                    color: #5D5D5D;
                    text-decoration: underline;

                }
            }

        }

    }

</style>



// WEBPACK FOOTER //
// src/components/newsDetail/news.vue